import http from './http';
import { handleResponse } from '@/shared/utils/promise-helpers';

export const getCampaignById = (idCampaign) =>
  http.get(`/campaigns/voice/${idCampaign}`).then(handleResponse);

export const getQueueById = (idQueue) =>
  http.get(`/queues/voice/${idQueue}`).then(handleResponse);

export const getQueues = () => http.get('/queues/voice').then(handleResponse);

export const getQueuesByOrg = (org) =>
  http.get(`/queues/voice/org-unit/${org}`).then(handleResponse);

export const getCampaigns = (agentId) =>
  http.get(`/agents/${agentId}/campaigns/voice`).then(handleResponse);

export const getCampaignsWithDialers = (agentId) =>
  http
    .get(`/agents/${agentId}/campaigns/voice`, {
      params: { withDialers: true },
    })
    .then(handleResponse);

export const getAgentsByVoiceCampaign = (voiceCampaign, agentId) =>
  http
    .get(`/campaigns/${voiceCampaign}/voice/agents-available`, {
      params: { agentId },
    })
    .then(handleResponse);

export const getAgentsByVoiceQueue = (voiceQueue, agentId) =>
  http
    .get(`/queues/${voiceQueue}/voice/agents-available`, {
      params: { agentId },
    })
    .then(handleResponse);

export const getDialersByVoiceCampaign = (campaignId) =>
  http.get(`/campaigns/voice/${campaignId}/dialer`).then(handleResponse);

export const transfer = (job) =>
  http.post('/job/voice/transfer', job).then(handleResponse);

export const transferRequest = (job) =>
  http.post('/job/voice/transfer-request', job).then(handleResponse);

export const transferAssistedAccept = (job) =>
  http.post('/job/voice/transfer-accept', job).then(handleResponse);

export const hangUpCall = (call) =>
  http.post('/voice/hang-up', call).then(handleResponse);

export const getScriptCampaign = (campaignId) =>
  http.get(`/campaigns/voice/${campaignId}/script`).then(handleResponse);

export const getScriptQueue = (queueId) =>
  http.get(`/queues/voice/${queueId}/script`).then(handleResponse);

export const getScript = async ({ voiceQueue, voiceCampaign }) => {
  if (voiceQueue) return getScriptQueue(voiceQueue);

  if (voiceCampaign) return getScriptCampaign(voiceCampaign);

  return Promise.resolve({});
};

export const activeJobVoice = (informations) =>
  http.post('/job/voice/active-job', informations);

export const qualifyJob = (qualification) =>
  http.post('/job/voice/qualify', qualification).then(handleResponse);

export const confirmPreferentialCall = (informations) =>
  http
    .post('/voice/confirm-preferencial-call', informations)
    .then(handleResponse);

export const getDialersRunning = () =>
  http.get('/dialer/running').then(handleResponse);

export const voiceRedial = (informations) =>
  http.post('/voice/redial', informations).then(handleResponse);

export const getVoiceNodes = (params) =>
  http.get(`/voice/get-nodes/${params.agent_id}`).then(handleResponse);

export const addToCall = (informations) =>
  http.post('/voice/start-conference', informations).then(handleResponse);

export const removeFromCall = (informations) =>
  http.post('/voice/end-conference', informations).then(handleResponse);
